import { colors } from "../colors_v2.js";
import { dasModal } from "../modal_v2.js";
import { identityService } from "./identityService_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { iPop } from "../ipop_v2.js";

var forgotPasswordState = {
  email: "",
  phase: "email",
  sendEmailCodeButtonFP: false,
  verifyEmailCodeButton: false,
  verifySecAButton: false,
  emailMsgFP: "",
  sendEmailCodeMsg: "",
  verifyRecoveryCodeMsg: "",
  verifyEmailCodeButtonMsg: "",
  secAMsg: "",
  secQ: "",
  verifySecAButtonMsg: "",
  submitPasswordFPButton: false,
  passwordFPMsg: "",
  submitPasswordFPMsg: "",
  // one-time token from the server, needed for the next recovery step
  recoveryToken: "",
};

const setButtonDisabledFromState = (buttonID) => {
  const button = document.getElementById(buttonID);
  button.disabled = forgotPasswordState[buttonID];
};

const setButtonDisabled = ({ buttonID, state }) => {
  const button = document.getElementById(buttonID);
  button.disabled = state;
  forgotPasswordState[buttonID] = state;
};

const setMessageElement = ({ elementID, message }) => {
  const element = document.getElementById(elementID);
  element.innerText = message;
  forgotPasswordState[elementID] = message;
};

const setMessageElementsFromState = (items) => {
  for (const item of items) {
    const element = document.getElementById(item);
    element.innerText = forgotPasswordState[item];
  }
};

const setPhase = (phase) => {
  forgotPasswordState.phase = phase;
  setSelected();
};

const clearForgotPasswordState = () => {
  forgotPasswordState = {
    email: "",
    phase: "email",
    sendEmailCodeButtonFP: false,
    verifyEmailCodeButton: false,
    verifySecAButton: false,
    emailMsgFP: "",
    sendEmailCodeMsg: "",
    verifyRecoveryCodeMsg: "",
    verifyEmailCodeButtonMsg: "",
    secAMsg: "",
    secQ: "",
    verifySecAButtonMsg: "",
    submitPasswordFPButton: false,
    passwordFPMsg: "",
    submitPasswordFPMsg: "",
    recoveryToken: "",
  };
};

// The server ended this recovery attempt (expired or too many tries).
// Go back to step 1, keeping the email, and show why.
const restartRecovery = (message) => {
  const email = forgotPasswordState.email;
  clearForgotPasswordState();
  forgotPasswordState.email = email;
  forgotPasswordState.sendEmailCodeMsg = message;
  renderEmail();
};

const render = () => {
  renderHeader();
  switch (forgotPasswordState.phase) {
    case "email":
      renderEmail();
      break;
    case "code":
      renderCode();
      break;
    case "secA":
      renderSecA();
      break;
    case "password":
      renderPassword();
      break;
  }
};

const setSelected = () => {
  removeSelected();
  switch (forgotPasswordState.phase) {
    case "email":
      document.getElementById("emailLi").classList.add("bold");
      document.getElementById("emailLi").classList.remove("gray");
      break;
    case "code":
      document.getElementById("codeLi").classList.add("bold");
      document.getElementById("codeLi").classList.remove("gray");
      break;
    case "secA":
      document.getElementById("secALi").classList.add("bold");
      document.getElementById("secALi").classList.remove("gray");
      break;
    case "password":
      document.getElementById("passwordLi").classList.add("bold");
      document.getElementById("passwordLi").classList.remove("gray");
      break;
  }
};

const removeSelected = () => {
  document.getElementById("emailLi").classList.remove("bold");
  document.getElementById("emailLi").classList.add("gray");
  document.getElementById("codeLi").classList.remove("bold");
  document.getElementById("codeLi").classList.add("gray");
  document.getElementById("secALi").classList.remove("bold");
  document.getElementById("secALi").classList.add("gray");
  document.getElementById("passwordLi").classList.remove("bold");
  document.getElementById("passwordLi").classList.add("gray");
};

const renderHeader = () => {
  const html = `
  <div class="popUpHead">Forgot Password</div>
  <p>Account recovery requires several steps:
    <ol>
      <li id="emailLi" class="left"> Enter your email address</li>
      <li id="codeLi" class="left"> Enter the code that is emailed</li>
      <li id="secALi" class="left"> Answer your security question<div id="secAFPSplainer" class="i">ⓘ</div></li>
      <li id="passwordLi" class="left"> Reset your password</li>
    </ol>
  <div class="phase" id="emailPhase"></div>
  <div class="phase" id="codePhase"></div>
  <div class="phase" id="secAPhase"></div>
  <div class="phase" id="passwordPhase"></div>
  <div id="forgotX" class = "x"></div>`;
  dasModal.render(html);
};

const renderSecAFPSplainer = (event) => {
  iPop.render({
    text: "If you didn't create a security question, then unfortunately there's no way to recover the account.",
    event,
  });
};

const hideAllPhases = () => {
  document.getElementById("emailPhase").innerHTML = "";
  document.getElementById("codePhase").innerHTML = "";
  document.getElementById("secAPhase").innerHTML = "";
  document.getElementById("passwordPhase").innerHTML = "";
};

const renderEmail = () => {
  hideAllPhases();
  setPhase("email");
  const html = `
  <div id="forgotPasswordForm">
    <div class="labelForInput">
      <label class="labelFP" for="email">1) Email:
        <input id="emailInputFP" class="inputFP" type="email" autocomplete="username email"></input>
        <div class="inputMessages" id="emailMsgFP"></div>
      </label>
    </div>
    <div id="crtButtons">
      <button id="sendEmailCodeButtonFP" class="RecoveryCodeButton button workADayButtons">Send Recovery Code</button>
      <div class="inputMessages" id="sendEmailCodeMsg"></div>
    </div>   
  </div>`;
  document.getElementById("emailPhase").innerHTML = html;
  const emailInputFP = document.getElementById("emailInputFP");
  emailInputFP.value = forgotPasswordState.email;
  emailInputFP.style.backgroundColor = colors.getGameColor("lighterAccent");

  emailInputFP.focus();
  colors.setButtonColors();
  setButtonDisabledFromState("sendEmailCodeButtonFP");
  setMessageElementsFromState(["emailMsgFP", "sendEmailCodeMsg"]);
};

const handleEmailFPKeyUp = (event) => {
  const emailInputFP = document.getElementById("emailInputFP");
  const result = identityService.isEmailValid(emailInputFP.value);
  if (result.status != 200) {
    setMessageElement({ elementID: "emailMsgFP", message: result.message });
    return;
  }
  // if they got through all that, then
  setMessageElement({ elementID: "emailMsgFP", message: "" });
};

const handleSendEmailCodeButtonFP = async (event) => {
  const emailInputFP = document.getElementById("emailInputFP");
  const email = emailInputFP.value;
  forgotPasswordState.email = email; // so other phases can access it
  const resultEmailValid = identityService.isEmailValid(email);
  if (resultEmailValid.status != 200) {
    setMessageElement({
      elementID: "sendEmailCodeMsg",
      message: "Please enter your email",
    });
    return;
  }
  setMessageElement({ elementID: "sendEmailCodeMsg", message: "" });
  setButtonDisabled({ buttonID: "sendEmailCodeButtonFP", state: true });
  document.body.style.cursor = "wait";
  await new Promise(requestAnimationFrame);
  // in this case, no matter how this comes back, we
  // tell them we sent the code
  await identityService.accountRecoveryCode({
    email: forgotPasswordState.email,
  });
  document.body.style.cursor = "default";
  // Let them request another code later (the server allows one a minute).
  forgotPasswordState.sendEmailCodeButtonFP = false;
  forgotPasswordState.verifyEmailCodeButton = false;
  forgotPasswordState.recoveryToken = "";
  setMessageElement({
    elementID: "sendEmailCodeMsg",
    message: "If an account was found, a code was emailed to it.",
  });
  forgotPasswordState.verifyEmailCodeButtonMsg =
    "The code works for 15 minutes. Check your spam folder if it doesn't arrive.";
  renderCode();
};

const renderCode = () => {
  hideAllPhases();
  setPhase("code");
  const html = `
    <br>
    <div class="labelForInput">
      <label class="labelFP" for="verifyRecoveryCode">2) Code:
        <input 
          id="verifyRecoveryCode" 
          class="inputFP" 
          type="text" 
          autocomplete="off"
          placeholder = "code that was emailed">
        </input>
        <div class="inputMessages" id="verifyRecoveryCodeMsg"></div>
      </label>
    <div class="center">
      <button id="verifyEmailCodeButton" class="verifyRecoveryCode button workADayButtons">Verify Recovery Code</button>
      <div class="inputMessages" id="verifyEmailCodeButtonMsg"></div>
    </div>
    </div>`;
  document.getElementById("codePhase").innerHTML = html;
  document.getElementById("verifyRecoveryCode").focus();
  colors.setButtonColors();
  const verifyRecoveryCode = document.getElementById("verifyRecoveryCode");
  verifyRecoveryCode.style.backgroundColor =
    colors.getGameColor("lighterAccent");
  setButtonDisabledFromState("verifyEmailCodeButton");
  setMessageElementsFromState([
    "verifyRecoveryCodeMsg",
    "verifyEmailCodeButtonMsg",
  ]);
};

const handleVerifyRecoveryCodeKeyUp = (event) => {
  event.stopPropagation();
  const verifyRecoveryCode = document.getElementById("verifyRecoveryCode");
  const result = identityService.isCodeValid(verifyRecoveryCode.value);
  if (result.status != 200) {
    setMessageElement({
      elementID: "verifyRecoveryCodeMsg",
      message: result.message,
    });
    return;
  }
  // if they got through all that, then
  setMessageElement({ elementID: "verifyRecoveryCodeMsg", message: "" });
};

const handlevVerifyEmailCodeButton = async (event) => {
  const recoveryCode = document.getElementById("verifyRecoveryCode").value;
  const resultCodeValid = identityService.isCodeValid(recoveryCode);
  if (resultCodeValid.status != 200) {
    setMessageElement({
      elementID: "verifyEmailCodeButtonMsg",
      message: resultCodeValid.message,
    });
    return;
  }
  setMessageElement({ elementID: "verifyEmailCodeButtonMsg", message: "" });
  setButtonDisabled({ buttonID: "verifyEmailCodeButton", state: true });
  document.body.style.cursor = "wait";
  await new Promise(requestAnimationFrame);
  setMessageElement({
    elementID: "verifyEmailCodeButtonMsg",
    message: "Verifying the code. This takes a moment...",
  });
  const result = await identityService.verifyAccountRecoveryCode({
    recoveryCode,
    email: forgotPasswordState.email,
  });
  document.body.style.cursor = "default";

  if (result.status != 200) {
    if (result.restart) {
      restartRecovery(result.message);
      return;
    }
    setButtonDisabled({ buttonID: "verifyEmailCodeButton", state: false });
    setMessageElement({
      elementID: "verifyEmailCodeButtonMsg",
      message: result.message || "The code does not match",
    });
    return;
  }
  setMessageElement({
    elementID: "verifyEmailCodeButtonMsg",
    message: "The code is verified",
  });
  forgotPasswordState.secQ = result.secQ;
  forgotPasswordState.recoveryToken = result.recoveryToken;
  renderSecA();
};

const renderSecA = () => {
  const secQ = forgotPasswordState.secQ;
  hideAllPhases();
  setPhase("secA");
  // secQ is user-entered text: set with textContent below, never in this HTML.
  const html = `
    <div id="yoursecA">Your Security Question is:</div>
    <div class="courier" id="secQFP"></div>
    <br>
    <div class="labelForInput">
      <label class="labelFP" for="verifyRecoveryCode">3) Security Answer:
        <input 
          id="secAFP" 
          class="inputFP" 
          type="text" 
          autocomplete="off">
        </input>
        <div class="inputMessages" id="secAMsg"></div>
      </label>
    <div class="center">
      <button id="verifySecAButton" class="verifyRecoveryCode button workADayButtons">Verify Security Answer</button>
      <div class="inputMessages" id="verifySecAButtonMsg"></div>
    </div>
    </div>`;
  document.getElementById("secAPhase").innerHTML = html;
  document.getElementById("secQFP").textContent = secQ;
  document.getElementById("secAFP").focus();
  colors.setButtonColors();
  const secAFP = document.getElementById("secAFP");
  secAFP.style.backgroundColor = colors.getGameColor("lighterAccent");
  setButtonDisabledFromState("verifySecAButton");
  setMessageElementsFromState(["secAMsg", "verifySecAButtonMsg"]);
};

const handleSecAKeyUp = async () => {
  const secAnswer = document.getElementById("secAFP").value;
  const result = await identityService.isSecQAValid(secAnswer);
  if (result.status != 200) {
    setMessageElement({
      elementID: "secAMsg",
      message: result.message,
    });
    return;
  }
  setMessageElement({ elementID: "secAMsg", message: "" });
};

const handlevVerifySecAButton = async (event) => {
  const secAnswer = document.getElementById("secAFP").value;
  const resultSecAValid = identityService.isSecQAValid(secAnswer);
  if (resultSecAValid.status != 200) {
    setMessageElement({
      elementID: "verifySecAButtonMsg",
      message: resultSecAValid.message,
    });
    return;
  }
  setMessageElement({ elementID: "verifySecAButtonMsg", message: "" });
  setButtonDisabled({ buttonID: "verifySecAButton", state: true });
  document.body.style.cursor = "wait";
  await new Promise(requestAnimationFrame);
  setMessageElement({
    elementID: "verifySecAButtonMsg",
    message: "Verifying the answer. This takes a moment...",
  });
  const result = await identityService.verifySecurityAnswer({
    secA: secAnswer,
    email: forgotPasswordState.email,
    recoveryToken: forgotPasswordState.recoveryToken,
  });
  document.body.style.cursor = "default";

  if (result.status != 200) {
    if (result.restart) {
      restartRecovery(result.message);
      return;
    }
    setButtonDisabled({ buttonID: "verifySecAButton", state: false });
    setMessageElement({
      elementID: "verifySecAButtonMsg",
      message:
        result.message ||
        "The answer is not correct.",
    });
    return;
  }
  setMessageElement({
    elementID: "verifySecAButtonMsg",
    message: "The security answer is verified.",
  });
  forgotPasswordState.recoveryToken = result.recoveryToken;
  renderPassword();
};

const renderPassword = () => {
  hideAllPhases();
  setPhase("password");
  const html = `
    <br>
    <div class="labelForInput">
      <label class="labelFP" for="verifyRecoveryCode">4) New Password:
        <input 
          id="passwordFP" 
          class="inputFP" 
          type="password" 
          autocomplete="new-password">
        </input>
        <div class="inputMessages" id="passwordFPMsg"></div>
      </label>
    <div class="center">
      <button id="submitPasswordFPButton" class="verifyRecoveryCode button workADayButtons">Submit</button>
      <div class="inputMessages" id="submitPasswordFPMsg"></div>
    </div>
    </div>`;
  document.getElementById("passwordPhase").innerHTML = html;
  colors.setButtonColors();
  const passwordFP = document.getElementById("passwordFP");
  passwordFP.focus();
  passwordFP.style.backgroundColor = colors.getGameColor("lighterAccent");
  setButtonDisabledFromState("submitPasswordFPButton");
  setMessageElementsFromState(["passwordFPMsg", "submitPasswordFPMsg"]);
};

const handlePasswordFPKeyUp = async (event) => {
  const passwordFP = document.getElementById("passwordFP");
  const password = passwordFP.value;
  const result = await identityService.isPasswordValid(password);
  if (result.status != 200) {
    setMessageElement({
      elementID: "passwordFPMsg",
      message: result.message,
    });
    return;
  }
  setMessageElement({ elementID: "passwordFPMsg", message: "" });
};

const handleSubmitPasswordFPButton = async () => {
  const password = document.getElementById("passwordFP").value;
  const resultPass = await identityService.isPasswordValid(password);
  if (resultPass.status != 200) {
    setMessageElement({
      elementID: "submitPasswordFPMsg",
      message: resultPass.message,
    });
    return;
  }

  setMessageElement({ elementID: "submitPasswordFPMsg", message: "" });
  setButtonDisabled({ buttonID: "submitPasswordFPButton", state: true });

  document.body.style.cursor = "wait";
  await new Promise(requestAnimationFrame);
  setMessageElement({
    elementID: "submitPasswordFPMsg",
    message: "Submitting...",
  });
  const result = await identityService.accountRecoveryPassword({
    password,
    email: forgotPasswordState.email,
    recoveryToken: forgotPasswordState.recoveryToken,
  });
  document.body.style.cursor = "default";

  if (result.status != 200) {
    if (result.restart) {
      restartRecovery(result.message);
      return;
    }
    setButtonDisabled({ buttonID: "submitPasswordFPButton", state: false });
    setMessageElement({
      elementID: "submitPasswordFPMsg",
      message: result.message || "Error: Unable to set the new password",
    });
    return;
  }

  setMessageElement({
    elementID: "submitPasswordFPMsg",
    message: "The password has been changed. Click the profile menu to log in.",
  });

  dasModal.close();
  dasModal.render(
    `<div class=max>The password has been changed. <br><br>Click the profile menu to log in</div>`,
  );
  clearForgotPasswordState();
};

/**
 * Enter in a step's input does the same as clicking that step's button.
 * Skipped while the button is disabled (a request is already in flight) and
 * while an IME is composing a character.
 */
const submitOnEnter = ({ buttonID, handler }) => (event) => {
  if (event.key !== "Enter") return;
  if (event.isComposing || event.keyCode === 229) return;
  event.preventDefault();
  const button = document.getElementById(buttonID);
  if (!button || button.disabled) return;
  handler(event);
};

eventHub.registerEvent(
  "keydown",
  "emailInputFP",
  submitOnEnter({
    buttonID: "sendEmailCodeButtonFP",
    handler: handleSendEmailCodeButtonFP,
  }),
);
eventHub.registerEvent(
  "keydown",
  "verifyRecoveryCode",
  submitOnEnter({
    buttonID: "verifyEmailCodeButton",
    handler: handlevVerifyEmailCodeButton,
  }),
);
eventHub.registerEvent(
  "keydown",
  "secAFP",
  submitOnEnter({
    buttonID: "verifySecAButton",
    handler: handlevVerifySecAButton,
  }),
);
eventHub.registerEvent(
  "keydown",
  "passwordFP",
  submitOnEnter({
    buttonID: "submitPasswordFPButton",
    handler: handleSubmitPasswordFPButton,
  }),
);
eventHub.registerEvent("keyup", "emailInputFP", handleEmailFPKeyUp);
eventHub.registerEvent(
  "click",
  "sendEmailCodeButtonFP",
  handleSendEmailCodeButtonFP,
);
eventHub.registerEvent(
  "keyup",
  "verifyRecoveryCode",
  handleVerifyRecoveryCodeKeyUp,
);
eventHub.registerEvent(
  "click",
  "verifyEmailCodeButton",
  handlevVerifyEmailCodeButton,
);
eventHub.registerEvent("keyup", "secAFP", handleSecAKeyUp);
eventHub.registerEvent("click", "verifySecAButton", handlevVerifySecAButton);
eventHub.registerEvent("keyup", "passwordFP", handlePasswordFPKeyUp);
eventHub.registerEvent(
  "click",
  "submitPasswordFPButton",
  handleSubmitPasswordFPButton,
);
eventHub.registerEvent("click", "secAFPSplainer", renderSecAFPSplainer);

export const forgotPassword = {
  render,
};
